import React from 'react'
import classNames from 'classnames'
import { CMSImage } from '@/ui/atoms/CMSImage'
import { Label } from '@/ui/atoms/Label'

type StandardCardSkeletonProps = {
  className?: string
}

export const StandardCardSkeleton: React.FC<StandardCardSkeletonProps> = ({
  className: classNameFromProps,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col rounded-md overflow-hidden bg-bg-subtle p-2',
        classNameFromProps,
      )}
    >
      <div className="animate-pulse relative w-full aspect-[16/9] overflow-hidden bg-neutral-90 mb-2 rounded-sm"></div>
      <div className="animate-pulse relative w-1/2 h-5 mb-2 bg-neutral-90 rounded-sm"></div>
      <div className="animate-pulse relative w-3/4 h-3 mb-1 bg-neutral-90 rounded-sm"></div>
      <div className="animate-pulse relative w-2/3 h-3 bg-neutral-90 rounded-sm"></div>
    </div>
  )
}
